var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcModalButtonLeftCorner = function SvgIcModalButtonLeftCorner(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 33 19"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F8957F",
    d: "M19.099 18.13H.106v-.89h18.362l11.254-9.905V0h1.3v7.642z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFD5B9",
    d: "M19.768 19H.106v-.89h19.005l11.65-10.533V.242h1.345v7.642z",
    opacity: 0.2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#E66549",
    d: "M18.416 17.2H.398v-.847h17.42l10.676-9.397V0h1.234v7.246z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E66549",
    d: "m21.816 11.273-4.282 4.56h-4.522l4.522-4.56z"
  })));
};
export default SvgIcModalButtonLeftCorner;